// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../config/styles';

const styles = theme => ({
  mainContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    minHeight: '80vh',
    zIndex: 10,
  },
  mainPaper: {
    margin: 20,
    borderRadius: 20,
    marginTop: 30,
    zIndex: 10,
    boxShadow: GlobalStyles.color.COLOR_SHADOW,
    position: 'relative',
    [theme.breakpoints.down(750)]: {
      width: '90%',
    },
  },
  mainContent: {
    width: 800,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 30,
    [theme.breakpoints.down(850)]: {
      width: 700,
    },
    [theme.breakpoints.down(750)]: {
      width: '100%',
      padding: 10,
    },
  },
  topTextContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  },
  arrowBackContainer: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    left: 20,
    marginBottom: 1,
  },
  link: {
    color: GlobalStyles.color.COLOR_GREY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE,
    cursor: 'pointer',
    '&:focus': {
      outline: 'none',
    },
  },
  loginTextContainer: {
    margin: 10,
    borderBottomColor: GlobalStyles.color.COLOR_GREEN,
    borderBottomWidth: 2,
    borderBottomStyle: 'solid',
  },
  formContainer: {
    marginTop: 20,
    marginBottom: 20,
    padding: 50,
    boxShadow: GlobalStyles.color.COLOR_SHADOW,
    borderRadius: 20,
  },
  topText: {
    marginBottom: 2,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_LARGE,
    [theme.breakpoints.down(450)]: {
      maxWidth: 250,
      textAlign: 'center',
    },
  },
});

export default styles;
